import React, { Component } from 'react';
import { Grid, Checkbox, FormControlLabel, TextField, Typography } from '@material-ui/core';
import BuscarSelect from "../general/BuscarSelect";

export default class SolicitudesAgregarMisDatos extends Component {
  render() {
    let {
      tipo_identificacion, tipos_identificacion, setTipo_identificacion,
      identificacion, primer_nombre, segundo_nombre, primer_apellido, segundo_apellido,
      barrio, direccion, departamentos, departamento, setDepartamento,
      ciudades, ciudad, setCiudad, setGenero, setComunidad, setTipo_discapacidad,
      telefono, correo, comunidad, comunidades,
      tipo_discapacidad_consultorio, tipos_discapacidad,
      genero, generos, egresado, checked, programas, setPrograma, programa, anho, onChange,
      rango_edad, rangos_edad, setRango_edad,
      nacionalidad,
      estrato_socioeconomico, estratos, setEstrato,
      grado_escolaridad, grados_escolaridad, setGrado_escolaridad,
      victima_violencia, victima_violencias, setVictima_violencia,
      cabeza_familia, cabezas_familia, setCabeza_familia,
      sabe_leer, opciones_sabe_leer, setSabe_leer,
    } = this.props.props_c;

    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Datos Personales
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={egresado}
                  onChange={checked}
                  id="egresado"
                  name="egresado"
                  color="primary"
                />
              }
              label="¿Eres Egresado CUC?"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <BuscarSelect
              datos={tipos_identificacion}
              cambiarEstado={(value) => setTipo_identificacion(value)}
              valor={tipo_identificacion}
              id='select-tipo-identificacion'
              nombre='¿Cuál es tu tipo de identificación?'
              placeholder='Seleccione Tipo'
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              value={identificacion}
              required
              type="number"
              id="identificacion"
              name="identificacion"
              label="Número de identificación"
              fullWidth
              autoComplete="fname"
              onChange={onChange}
            />
            <Typography variant="body2" component="p">Sin puntos ni comas.</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField value={primer_nombre} required type="text" id="primer_nombre" name="primer_nombre" label="Primer Nombre" fullWidth onChange={onChange} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField value={segundo_nombre} type="text" id="segundo_nombre" name="segundo_nombre" label="Segundo Nombre" fullWidth onChange={onChange} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField value={primer_apellido} required type="text" id="primer_apellido" name="primer_apellido" label="Primer Apellido" fullWidth onChange={onChange} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField value={segundo_apellido} type="text" id="segundo_apellido" name="segundo_apellido" label="Segundo Apellido" fullWidth onChange={onChange} />
          </Grid>

          {egresado === true && (
            <>
              <Grid item xs={12} md={6}>
                <BuscarSelect datos={programas} cambiarEstado={(value) => setPrograma(value)} valor={programa} id='select-programa' nombre='Programa' placeholder='Seleccione Programa de Egreso' />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField value={anho} type="number" id="anho" name="anho" label="Año de Egreso" fullWidth onChange={onChange} />
              </Grid>
            </>
          )}

          <Grid item xs={12} md={6}>
            <TextField value={direccion} required type="text" id="direccion" name="direccion" label="Dirección" fullWidth onChange={onChange} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField value={barrio} required type="text" id="barrio" name="barrio" label="Barrio" fullWidth onChange={onChange} />
          </Grid>
          <Grid item xs={12} md={6}>
            <BuscarSelect datos={departamentos} cambiarEstado={(value) => setDepartamento(value)} valor={departamento} id='select-departamento' nombre='Departamento' placeholder='Seleccione Departamento' />
          </Grid>
          <Grid item xs={12} md={6}>
            <BuscarSelect datos={ciudades} cambiarEstado={(value) => setCiudad(value)} valor={ciudad} id='select-ciudad' nombre='Ciudad' placeholder='Seleccione Ciudad' />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField value={telefono} required type="number" id="telefono" name="telefono" label="Teléfono" fullWidth onChange={onChange} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField value={correo} required type="text" id="correo" name="correo" label="Email" fullWidth onChange={onChange} />
          </Grid>
          <Grid item xs={12} md={6}>
            <BuscarSelect datos={comunidades} cambiarEstado={(value) => setComunidad(value)} valor={comunidad} id='select-comunidad' nombre='Comunidad' placeholder='Seleccione Comunidad' />
          </Grid>
          <Grid item xs={12} md={6}>
            <BuscarSelect datos={generos} cambiarEstado={(value) => setGenero(value)} valor={genero} id='select-genero' nombre='Género' placeholder='Seleccione Género' />
          </Grid>
          <Grid item xs={12} md={6}>
            <BuscarSelect datos={tipos_discapacidad || []} cambiarEstado={(value) => setTipo_discapacidad(value)} valor={tipo_discapacidad_consultorio} id='select-discapacidad' nombre='¿Tiene alguna discapacidad?' placeholder='Seleccione' />
          </Grid>
          {/* ── Sección Datos Sociodemográficos ── */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" style={{ marginTop: 8, fontWeight: 600, borderBottom: '1px solid #e0e0e0', paddingBottom: 4 }}>
              Datos Sociodemográficos
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <BuscarSelect
              datos={rangos_edad || []}
              cambiarEstado={(value) => setRango_edad(value)}
              valor={rango_edad}
              id='select-rango-edad'
              nombre='Rango de edad'
              placeholder='Seleccione rango'
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              value={nacionalidad || ''}
              type="text"
              id="nacionalidad"
              name="nacionalidad"
              label="Nacionalidad"
              fullWidth
              onChange={onChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <BuscarSelect
              datos={estratos || []}
              cambiarEstado={(value) => setEstrato(value)}
              valor={estrato_socioeconomico}
              id='select-estrato'
              nombre='Estrato socioeconómico'
              placeholder='Seleccione estrato'
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <BuscarSelect
              datos={grados_escolaridad || []}
              cambiarEstado={(value) => setGrado_escolaridad(value)}
              valor={grado_escolaridad}
              id='select-escolaridad'
              nombre='Grado de escolaridad'
              placeholder='Seleccione grado'
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <BuscarSelect
              datos={victima_violencias || []}
              cambiarEstado={(value) => setVictima_violencia(value)}
              valor={victima_violencia}
              id='select-victima-violencia'
              nombre='Víctima de violencia'
              placeholder='Seleccione una'
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <BuscarSelect
              datos={cabezas_familia || []}
              cambiarEstado={(value) => setCabeza_familia(value)}
              valor={cabeza_familia}
              id='select-cabeza-familia'
              nombre='¿Es madre o cabeza de familia?'
              placeholder='Seleccione'
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <BuscarSelect
              datos={opciones_sabe_leer || []}
              cambiarEstado={(value) => setSabe_leer(value)}
              valor={sabe_leer}
              id='select-sabe-leer'
              nombre='¿Sabe leer?'
              placeholder='Seleccione'
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}
